exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-row[data-v-299a754f] {\n  margin-bottom: 10px;\n}\n.my-aside[data-v-299a754f] {\n  border-right: 1px solid #409eff;\n  margin-right: 10px;\n}\n", ""]);

// exports
